// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1406": "2fafa60e","309": "6c986c56","5187": "df9389b7",}[chunkId] + ".css"
}